// src/app/components/reporting/format.ts
//
// Sentence case, for values that are stored in Title Case.
//
// Bug 1c of the handoff: "Headlines and buttons are sentence case." Most of
// that is a text edit. The audience and format values are not — they are sent
// to the API in `ReportGenerateRequest` and come back on `GeneratedReport`, and
// there are rows in the table carrying the Title Case spelling already. The
// data contract is frozen, so the VALUES stay exactly as they are and the
// DISPLAY is cased here.
//
// That also fixes the rows that already exist, which a change at the write end
// could not have done.
//
// "C-Suite / Board" → "C-suite / board"    (the DC's own spelling)
// "Executive Summary" → "Executive summary"
// "Sales Deck" → "Sales deck"

/** Lowercase the lot, then raise the first letter that is one. */
export function sentenceCase(value: string): string {
  const lower = value.toLowerCase();
  const at = lower.search(/[a-z]/);
  if (at < 0) return lower;
  return lower.slice(0, at) + lower.charAt(at).toUpperCase() + lower.slice(at + 1);
}
